import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { applications } from './applications';
import { candidates } from './candidates';
import { interviews } from './interviews';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const interviewInvites = pgTable(
  'interview_invites',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    applicationId: uuid('application_id')
      .notNull()
      .references(() => applications.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    interviewId: uuid('interview_id')
      .notNull()
      .references(() => interviews.id),
    token: text('token').notNull().unique(),
    expiresAt: timestamp('expires_at', { withTimezone: true }),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp('updated_at', { withTimezone: true })
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    index('interview_invites_application_id_idx').on(t.applicationId),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
